import { ButtonRoundSm } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { UNIT_STATUS_ACTIVE } from '@apps-common/config/unit-filter'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { IMyMonitoringAccountListModel } from '@apps-common/types/portal/my-monitoring'
import { ROUTE_UNIT_MANAGE } from '@apps-radionet-portal-root/src/config/private-routes'
import { Tooltip } from 'react-tooltip'

interface IProps {
  take?: number
  props: IMyMonitoringAccountListModel
}

export const MyMonitoringAccountSitePills: React.FC<IProps> = ({ props, take = 3 }) => {
  const { navigateForward } = useNavigation()
  const remainder = props?.units?.split(',')?.splice(take)

  return (
    <div className='flex flex-wrap gap-[5px]'>
      {(!props?.units || props?.units?.length === 0) && 'No sites'}
      {props?.units &&
        props?.units?.length > 0 &&
        props?.units
          ?.split(',')
          ?.splice(0, take)
          ?.map((u: string) => {
            const unitSplit = u.split('|')

            if (unitSplit?.length < 3) {
              return <div />
            }

            return (
              <ButtonRoundSm
                type='button'
                className='bg-surface border border-border !w-auto !h-[22px] pr-[1px] pl-[6px] gap-1'
                callback={(e) => {
                  e?.stopPropagation()
                  navigateForward({
                    routeUrl: ROUTE_UNIT_MANAGE.buildPath(UNIT_STATUS_ACTIVE.value, unitSplit[0]),
                    route: ROUTE_UNIT_MANAGE
                  })
                }}
                tooltip={{
                  id: `navigate-my-monitoring-account-unit-${unitSplit[0]}`,
                  message: unitSplit[2].length > 0 ? unitSplit[2] : `View device ${unitSplit[1]}`
                }}
              >
                <span className='text-[0.7rem] jost'>{unitSplit[1]}</span>
                <div className='bg-surface-2 border border-border h-[18px] w-[18px] rounded-full flex items-center justify-center'>
                  <commonIcons.arrowAngled className='text-[0.9rem]' />
                </div>
              </ButtonRoundSm>
            )
          })}
      {remainder.length > 0 && (
        <div
          data-tooltip-id='my-monitoring-sites-list-remainder-tooltip'
          data-tooltip-html={remainder
            .map((u: string) => {
              try {
                const unitSplit = u.split('|')

                if (unitSplit.length < 3) {
                  return null
                }

                return unitSplit[2]
              } catch {
                return null
              }
            })
            .filter(Boolean)
            .join('<br/>')}
        >
          <div className='bg-surface-2 text-text border border-border rounded-full text-[0.7rem] leading-[0.8rem] px-1 py-1 !cursor-default'>
            +{remainder.length} more
          </div>{' '}
          <Tooltip
            id='my-monitoring-sites-list-remainder-tooltip'
            place='top'
            className='hidden sm:inline-block !bg-surface !text-text !drop-shadow-sm z-[60]'
          />
        </div>
      )}
    </div>
  )
}
